import React from 'react'
import {
  Box,
  Grid,
} from '@material-ui/core'
import { Stack, Checkbox, Typography } from '@mui/material'
import { Controller } from 'react-hook-form'
import { TimePicker } from './form/DateTimePicker'
import { GalleryFormFieldLabel } from './GalleryFormFieldLabel'


export const GalleryShotAtTimeFormField = ({
  control,
  classes,
}) => {

  const inputStyling = {
    padding: '0px 10px',
    background: '#ebebeb',
    width: 253,
    height: 25,
    fontWeight: 400,
    fontSize: 12,
    color: '#606060'
    }
  
  return (
    <Grid item xs={ 12 }>
      <Box sx={{ display: 'flex', gap: '10px' }}>
         <GalleryFormFieldLabel label='Time'/>
          <Typography sx={inputStyling}>
            <Controller
              name='shot_at_time'
              control={ control }
              label='Start time of shoot'
              render={(fieldProps) => (
                <Box>
                  <span classname={ classes.placeHolderSize }>
                    <TimePicker
                      autoOk
                      classes={ classes }
                      fieldProps={ fieldProps }
                      className={ classes.gallery_activity_form_field }
                    />
                  </span>
                </Box>
              )}
            />
          </Typography>
        </Box>
      </Grid>
    )
  }
